import ModalDoubleAction from "@/app/components/ui/Modals/DoubleAction";
import { useSendAppRequestAPI } from "@/app/hooks/api_hooks/org/useSendAppRequestAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { startCase } from "lodash";
import { FcAndroidOs } from "react-icons/fc";
import { ISendAppRequestModalProps } from "../interface";

const SendAppRequestModal: React.FC<ISendAppRequestModalProps> = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerDetails, customerId } = routeState.state as ICustomerProfileState;
  const sendAppRequest = useSendAppRequestAPI();

  return (
    <ModalDoubleAction
      showIcon
      isConfirmLayout
      modalId="NO_APP_SEND_REQUEST"
      button={{
        primaryButtonText: "Send App Request",
        secondaryButtonText: "Cancel",
        primaryButtonClassname: "bg-[#193A6A] text-white hover:bg-[#14305a] focus-visible:outline-[#193A6A]",
        primaryCallback: () => {
          if (customerId) {
            sendAppRequest(customerId);
          }
        },
        shouldHideOnClick: true,
      }}
      content={
        <span className="text-xs text-gray-500">
          Send app download request to{" "}
          <span className="font-medium text-gray-900">{startCase(customerDetails?.name)}</span>
        </span>
      }
      title="Send App Request"
      titleIcon={
        <span className="text-2xl">
          <FcAndroidOs />
        </span>
      }
      titleIconClassName="text-green-500"
    />
  );
};

export default SendAppRequestModal;
